import type { MenuId } from '@atlassian/jira-navigation-apps-common/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EntryPointParams = {
	menuId: MenuId;
};

export const topNavigationEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-atlassian-navigation" */ './src/ui'),
	),
	getPreloadProps: (extraProps: EntryPointParams) => ({
		extraProps,
	}),
});
